const gender = [
    {
      gender: 'Uomo',
    },
    {
      gender: 'Donna',
    },
    {
      gender: 'Altro',
    },
  ];
  
  export default gender;
  